import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StopPropagationDirectiveModule } from '../../../directives';
import { SiListGroupSelectableComponent } from './si-list-group-selectable.component';
import { DisableAutocompleteDirectiveModule } from 'src/app/shared/directives';
import { MatListModule } from '@angular/material/list';

@NgModule({
    imports: [
        DisableAutocompleteDirectiveModule,
        CommonModule,
        StopPropagationDirectiveModule,
        MatListModule,
    ],
    declarations: [SiListGroupSelectableComponent],
    exports: [SiListGroupSelectableComponent]
})
export class SiListGroupSelectableModule {}
